import TextField from './TextField';

const TextFieldButton = ({
  type,
  name,
  content,
  label,
  widthClass = 'w-[120px]',
  ...props
}) => {
  return (
    <div className={widthClass}>
      <TextField
        name={name}
        label={label}
        type={type}
        suffix={content}
        {...props}
      />
    </div>
  );
};

export default TextFieldButton;
